import { render, staticRenderFns } from "./FormType.vue?vue&type=template&id=5c6264e6&"
import script from "./FormType.vue?vue&type=script&lang=js&"
export * from "./FormType.vue?vue&type=script&lang=js&"
import style0 from "./FormType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports